import { XIcon } from '@heroicons/react/outline'
import { amplitude } from 'components/app/Amplitude'
import Button from 'components/base/Button'
import dayjs from 'dayjs'
import { FC, c } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import { useIntl } from 'lib/intl-utils'
import { storage } from 'lib/local-storage'
import { useEffect } from 'react'

const QuizBanner: FC<{ onDismiss: () => void }> = ({ onDismiss }) => {
  const ctx = useUserContext()
  const { format } = useIntl()

  useEffect(() => {
    amplitude.track('Banner Viewed', {
      bannerId: 'quizProductCardDesign',
      scope: 'landing',
      host: ctx.theme.hostType,
    })
  }, [ctx.theme.hostType])

  return (
    <div className="fixed z-40 bottom-12 inset-x-2 sm:left-1/2 sm:inset-x-auto sm:w-max sm:max-w-[calc(100%-2rem)] sm:-translate-x-1/2 min-[1009px]:bottom-8">
      <div
        className={c`relative flex w-full flex-col gap-2 rounded-2xl bg-gray-800 p-4 pr-11 text-white shadow-2xl ring-1 ring-white/10 sm:w-max sm:flex-row sm:items-center sm:gap-0 sm:rounded-full sm:p-0 sm:py-2.5 sm:pl-6 sm:pr-3`}
      >
        <div className="flex items-start gap-2.5 sm:contents">
          <span className="shrink-0 text-2xl leading-none sm:mr-2.5" aria-hidden="true">
            🚀
          </span>
          <div className="flex min-w-0 flex-col gap-2 sm:contents">
            <p className="min-w-0 text-sm leading-snug text-white sm:mr-6 sm:shrink-0 min-[1009px]:text-base min-[1009px]:leading-none min-[1009px]:whitespace-nowrap">
              Пройдите тест по WB и заберите подарки на сумму {format.price(10000)}
            </p>
            <a
              href="https://app.sellmonitor.com/marquiz/?utm_source=marquiz&utm_medium=banner_site&utm_campaign=infografika"
              target="_blank"
              rel="noreferrer"
              className="w-fit rounded-full bg-white px-3.5 py-1.5 text-xs font-semibold text-black transition-colors duration-150 hover:bg-white/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white min-[1009px]:px-5 min-[1009px]:py-2.5 min-[1009px]:text-sm"
              onClick={() => {
                amplitude.track('Banner CTA Clicked', {
                  bannerId: 'quizProductCardDesign',
                  scope: 'landing',
                  host: ctx.theme.hostType,
                })
              }}
            >
              Открыть
            </a>
          </div>
        </div>
        <Button
          theme="gray"
          className="absolute right-2 top-1/2 shrink-0 -translate-y-1/2 !px-2 !text-white/50 hover:!text-white sm:static sm:translate-y-0 sm:ml-1"
          onClick={() => {
            amplitude.track('Banner Closed', {
              bannerId: 'quizProductCardDesign',
              scope: 'landing',
              host: ctx.theme.hostType,
            })
            const closedTimes = storage.get('landing:quiz:AdClosed:times') || 0
            storage.set('landing:quiz:AdClosed:times', closedTimes + 1)
            storage.set('landing:quiz:AdClosed:date', dayjs().toISOString())
            onDismiss()
          }}
        >
          <XIcon className="h-4 w-4" aria-hidden="true" />
        </Button>
      </div>
    </div>
  )
}

export default QuizBanner
